import request from '@/axios'

// 获取所有字典
export const getDictApi = () => {
  return request.get({ url: '/mock/dict/list' })
}

// 模拟获取某个字典
export const getDictOneApi = async () => {
  return request.get({ url: '/mock/dict/one' })
}

// 获取权限
export const getPermissionsApi = () => {
  return request.get({ url: '/admin/auth/permissions' })
}

// 获取首页统计数据
export const getStatisticsApi = () => {
  return request.get({ url: '/admin/statistics' })
}

export const getRebateConfigApi = () => {
  return request.get({ url: '/admin/common/rebate-config' })
}

export const getCurrencyApi = () => {
  return request.get({ url: '/pro-channel-page/common/currency' })
}

export const getPaymentChannelApi = () => {
  return request.get({ url: '/pro-channel-page/filter/payment-channel' })
}

export const getUserDepositFilterDataApi = () => {
  return request.get({ url: '/pro-channel-page/user-deposit/filter-data' })
}

export const getChannelInfoApi = () => {
  return request.get({ url: '/pro-channel-page/common/channel-info' })
}
